import { inject } from "@angular/core";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { RouteService } from "@app/core/services/route.service";
import { ROUTES } from "@app/shared/constants/routes.constants";

export const TwoFactorAuthenticationGuard = () => {
  const authService = inject(AuthenticationService);
  const routeService = inject(RouteService);

  if (!authService.isAuthenticated()) {
    routeService.navigate([ROUTES.LOGIN]);
    return false;
  }

  if (authService.key2FA && authService.is2faAuthenticated()) {
    routeService.navigateHome();
    return false;
  }

  return true;
};
